const formEl = document.querySelector('#CreateCustomer');
const resetPasswordForm = document.querySelector('#ResetCustomerPassword');
const passwordInputEl = document.querySelector('#CreatePassword');
const confirmPasswordEl = document.querySelector('#CreatePasswordConfirm');
const resetPasswordEl = document.querySelector('#ResetPassword');
const confirmResetPasswordEl = document.querySelector('#PasswordConfirmation');

const isValidated = (inputEl) => {
  const validationStates = {
    symbol: false,
    UpperCase: false,
    LowerCase: false,
    number: false,
    length: false,
  };
  validationStates.symbol = /[^a-zA-Z0-9]/.test(inputEl.value);
  validationStates.UpperCase = /[A-Z]/.test(inputEl.value);
  validationStates.LowerCase = /[a-z]/.test(inputEl.value);
  validationStates.number = /[0-9]/.test(inputEl.value);
  validationStates.length = inputEl.value.length >= 8;

  const isValid = Object.values(validationStates).every((value) => value);
  return isValid;
};

formEl?.addEventListener('submit', (event) => {
  const isPasswordValid = isValidated(passwordInputEl);
  if (!isPasswordValid || passwordInputEl.value !== confirmPasswordEl.value) {
    event.preventDefault();
    event.stopImmediatePropagation();
  } else {
    formEl.submit();
  }
});

resetPasswordForm?.addEventListener('submit', (event) => {
  const isPasswordValid = isValidated(resetPasswordEl);
  if (!isPasswordValid || resetPasswordEl.value !== confirmResetPasswordEl.value) {
    event.preventDefault();
    event.stopImmediatePropagation();
  } else {
    formEl.submit();
  }
});
